export { default } from "./Swiper"
